export const BREAK_POINT_MIN = 360;
export const BREAK_POINT_TABLET = 768;
export const BREAK_POINT_MAX = 1140;

export const MEDIA_TABLET = "(min-width: " + BREAK_POINT_TABLET + ")";
